import { render } from "./HsTextarea.vue?vue&type=template&id=18253f5d&scoped=true"
import script from "./HsTextarea.vue?vue&type=script&lang=js"
export * from "./HsTextarea.vue?vue&type=script&lang=js"

import "./HsTextarea.vue?vue&type=style&index=0&id=18253f5d&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-18253f5d"]])

export default __exports__